import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FormHelperText, MenuItem, Select, styled } from "__barrel_optimize__?names=FormHelperText,MenuItem,Select,styled!=!@mui/material";
import React from "react";
const CustomSelect = styled(Select)(()=>({
        "& .MuiInputBase-input": {
            padding: "15px 19px",
            fontSize: "14px",
            fontWeight: 500
        }
    }));
const StyledSelect = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { options, helperText, translate, placeholder, ...rest } = props;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(CustomSelect, {
                ref: ref,
                sx: {
                    "& legend": {
                        display: "none"
                    },
                    "& fieldset": {
                        top: 0
                    }
                },
                displayEmpty: Boolean(placeholder),
                renderValue: (selected)=>{
                    if (placeholder && (selected === "" || selected === undefined || selected === null)) {
                        return /*#__PURE__*/ _jsx("span", {
                            style: {
                                color: "#A9ABC1"
                            },
                            children: placeholder
                        });
                    }
                    const matchedOption = options === null || options === void 0 ? void 0 : options.find((option)=>option.value === selected);
                    if (matchedOption) {
                        return translate ? translate(matchedOption.label) : matchedOption.label;
                    }
                    return selected;
                },
                ...rest,
                children: options.map((option)=>/*#__PURE__*/ _jsx(MenuItem, {
                        value: option.value,
                        children: translate ? translate(option.label) : option.label
                    }, option.value))
            }),
            helperText ? /*#__PURE__*/ _jsx(FormHelperText, {
                sx: {
                    color: "#bf3333",
                    marginLeft: "16px !important"
                },
                children: helperText && helperText
            }) : null
        ]
    });
});
StyledSelect.displayName = "StyledSelect";
export default StyledSelect;
